
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { Subscription } from 'rxjs';
import { AccountEndpoint } from '../../../services/account-endpoint.service';
import { AccountService } from '../../../services/account.service';
import { CoTwoService } from '../../../services/cotwo.service';
import { DBkeys } from '../../../services/db-Keys';
import { LocalStoreManager } from '../../../services/local-store-manager.service';
let _ = require('lodash');
require('chart.js');

@Component({
    selector: 'cotwo-statistics',
    template: require('./cotwo-statistics.component.html'),
    styles: [require('./cotwo-statistics.component.css')],
})
export class CoTwoStatisticsComponent implements OnInit, OnDestroy {
    private subscribers: Subscription[] = [];

    @Input('monthsCount') monthsCount: number;
    cotwoStatistics: any;
    cotwoCount: number;
    suggestedMin: number = 10;
    suggestedMax: number = 20;
    Min: number = 10;
    Max: number = 20;
    chartData: Array<any> = [];
    chartLabels: Array<any> = [];
    chartOptions: any;
    chartColors: Array<any> = [
        {
            // Light red
            backgroundColor: 'rgba(255, 99, 132, 0.2)',
            borderColor: 'rgba(255, 99, 132, 1)',
            pointBackgroundColor: 'rgba(255, 99, 132, 1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(255, 99, 132, 0.8)'
        },
        {
            // Bright blue
            backgroundColor: 'rgba(54, 162, 235, 0.2)',
            borderColor: 'rgba(54, 162, 235, 1)',
            pointBackgroundColor: 'rgba(54, 162, 235, 1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(54, 162, 235, 0.8)'
        },
        {
            // Light orange
            backgroundColor: 'rgba(255, 206, 86, 0.2)',
            borderColor: 'rgba(255, 206, 86, 1)',
            pointBackgroundColor: 'rgba(255, 206, 86, 1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(255, 206, 86, 1)'
        },
        {
            // Moderate cyan
            backgroundColor: 'rgba(75, 192, 192, 0.2)',
            borderColor: 'rgba(75, 192, 192, 1)',
            pointBackgroundColor: 'rgba(75, 192, 192, 1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(75, 192, 192,0.8)'
        }
    ];
    chartLegend: boolean = true;
    chartType: string = 'line';
    loading: boolean = false;
    applicationVersionName: any;

    constructor(private cotwoService: CoTwoService, private ngxLogger: NGXLogger, private storageManager: LocalStoreManager,
        private accountService: AccountService, private accountEndpoint: AccountEndpoint) { }

    ngOnInit() {
        this.loading = true;
        this.applicationVersionName = this.accountService.applicationVersionName;
        const cotwoStaSubscriber = this.cotwoService.getStatistics(this.monthsCount).subscribe((res: any) => {
            this.loading = false;

            if (res.Item2 && res.Item1 != null) {
                this.refreshChart(res.Item1, res.Item3);
            } else {
                let OChartData, OChartLabels, OMin, OMax;
                if (res.Item3) {
                    OChartData = this.storageManager.getchartData(this.storageManager.getApplicationVersion(DBkeys.APPLICATIONVERSION) + "_" + DBkeys.COTWOTRIALCHARTDATA);
                    OChartLabels = this.storageManager.getchartData(this.storageManager.getApplicationVersion(DBkeys.APPLICATIONVERSION) + "_" + DBkeys.COTWOTRIALCHARTLABELS);
                    OMin = this.storageManager.getMin(this.storageManager.getApplicationVersion(DBkeys.APPLICATIONVERSION) + "_" + DBkeys.COTWOTRIALMIN);
                    OMax = this.storageManager.getMax(this.storageManager.getApplicationVersion(DBkeys.APPLICATIONVERSION) + "_" + DBkeys.COTWOTRIALMAX);
                } else {
                    OChartData = this.storageManager.getchartData(this.storageManager.getApplicationVersion(DBkeys.APPLICATIONVERSION) + "_" + DBkeys.COTWOCHARTDATA);
                    OChartLabels = this.storageManager.getchartData(this.storageManager.getApplicationVersion(DBkeys.APPLICATIONVERSION) + "_" + DBkeys.COTWOCHARTLABELS);
                    OMin = this.storageManager.getMin(this.storageManager.getApplicationVersion(DBkeys.APPLICATIONVERSION) + "_" + DBkeys.COTWOMIN);
                    OMax = this.storageManager.getMax(this.storageManager.getApplicationVersion(DBkeys.APPLICATIONVERSION) + "_" + DBkeys.COTWOMAX);
                }

                if (OChartData != null && OChartLabels != null && OMin != null && OMax != null) {
                    this.refreshMemoryChart(OChartData, OChartLabels, OMin, OMax);
                } else if (OChartData == null || OChartLabels == null || OMin == null || OMax == null) {
                    this.cotwoService.getCacheStatistics(this.monthsCount).subscribe((res: any) => {
                        if (res.Item1 != null) {
                            this.refreshChart(res.Item1, res.Item2);
                        }
                    });
                }
            }
        }, error => {
            this.loading = false;
            this.ngxLogger.error(error.message);
            throw error;
        });

        this.subscribers.push(cotwoStaSubscriber);
    }

    refreshChart(res, trial) {
        let temp = _(res)
            .map((value, key) => ({ Data: value.SettlementPrice }))
            .value();

        this.Max = Math.max.apply(Math, temp.map(function (o) { return o.Data; }));
        this.Min = Math.min.apply(Math, temp.map(function (o) { return o.Data; }));

        this.cotwoStatistics = _(res).groupBy(x => x.StripName.substring(3, x.StripName.length))
            .map((value, key) => ({ StripName: key, Data: value }))
            .value();

        // creates an array of the `value` property: [100, 22, 12]
        let numbers = this.cotwoStatistics.map(i => i.Data.length);

        // gets the sum of the array of numbers: 134
        this.cotwoCount = numbers.reduce((a, b) => a + b, 0);
        this.loading = false;

        if (this.cotwoStatistics != null && this.cotwoStatistics !== undefined && this.cotwoStatistics.length > 0) {
            let _chartData: Array<any> = [{ data: new Array(this.cotwoStatistics.length) }];
            let _chartLabels: Array<any> = new Array(this.cotwoStatistics[0].Data.length);
            _chartLabels = _.map(this.cotwoStatistics[0].Data, 'Datum');
            for (let i = 0; i < this.cotwoStatistics.length; i++) {
                _chartData[i] = { data: new Array(this.cotwoStatistics[i].Data.length), label: "Cal " + this.cotwoStatistics[i].StripName };
                for (let j = 0; j < this.cotwoStatistics[i].Data.length; j++) {
                    _chartData[i].data[j] = this.cotwoStatistics[i].Data[j].SettlementPrice;
                }
            }

            this.chartData = _chartData;
            this.chartLabels = _chartLabels;
            this.chartOptions = {
                responsive: true,
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                            suggestedMin: this.suggestedMin,
                            suggestedMax: this.suggestedMax,
                            min: this.Min,
                            max: this.Max
                        }
                    }]
                },
                elements: {
                    line: {
                        fill: false
                    },
                    point: {
                        radius: 0
                    }
                }
            };
            if (this.applicationVersionName == null || this.applicationVersionName == undefined) {
                this.accountEndpoint.getApplicationVersionName().subscribe(res => {
                    this.applicationVersionName = res;
                    this.GetdataLocalSt(trial, _chartData, _chartLabels);
                });
            } else {
                this.storageManager.setApplicationVersion(this.applicationVersionName, DBkeys.APPLICATIONVERSION);
                this.GetdataLocalSt(trial, _chartData, _chartLabels);
            }
        }
    }

    GetdataLocalSt(trial, _chartData, _chartLabels) {
        if (trial) {
            this.storageManager.setchartData(_chartData, this.applicationVersionName + "_" + DBkeys.COTWOTRIALCHARTDATA);
            this.storageManager.setchartLabels(_chartLabels, this.applicationVersionName + "_" + DBkeys.COTWOTRIALCHARTLABELS);
            this.storageManager.setMax(this.Max, this.applicationVersionName + "_" + DBkeys.COTWOTRIALMAX);
            this.storageManager.setMin(this.Min, this.applicationVersionName + "_" + DBkeys.COTWOTRIALMIN);

        } else {
            this.storageManager.setchartData(_chartData, this.applicationVersionName + "_" + DBkeys.COTWOCHARTDATA);
            this.storageManager.setchartLabels(_chartLabels, this.applicationVersionName + "_" + DBkeys.COTWOCHARTLABELS);
            this.storageManager.setMax(this.Max, this.applicationVersionName + "_" + DBkeys.COTWOMAX);
            this.storageManager.setMin(this.Min, this.applicationVersionName + "_" + DBkeys.COTWOMAX);
        }
    }

    refreshMemoryChart(OChartData, OChartLabels, OMin, OMax) {

        this.cotwoStatistics = OChartData;
        this.chartData = OChartData;
        this.chartLabels = OChartLabels;
        this.Min = OMin;
        this.Max = OMax;
        this.chartOptions = {
            responsive: true,
            scales: {
                yAxes: [{
                    ticks: {
                        beginAtZero: true,
                        suggestedMin: this.suggestedMin,
                        suggestedMax: this.suggestedMax,
                        min: this.Min,
                        max: this.Max
                    }
                }]
            },
            elements: {
                line: {
                    fill: false
                },
                point: {
                    radius: 0
                }
            }
        };
    }

    ngOnDestroy() {
        if (this.subscribers) {
            this.subscribers.forEach(s => s.unsubscribe());
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/cotwo/cotwo-statistics/cotwo-statistics.component.ts